import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SEO } from '../components/SEO';

/**
 * 404 page with a `noindex, follow` meta tag so Google de-indexes the URL
 * even though the HTTP response from the SPA catch-all is 200.
 * Also signals a semantic not-found via X-Robots-style meta.
 */
export default function NotFoundPage() {
  const { language } = useLanguage();
  const isDe = language === 'de';

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E7F0FA] pt-20" data-testid="not-found-page">
      <SEO
        title={isDe ? 'Seite nicht gefunden' : 'Page not found'}
        description={isDe
          ? 'Die angeforderte Seite existiert nicht oder wurde verschoben.'
          : 'The requested page does not exist or has been moved.'}
        path="/404"
        lang={language}
        noindex={true}
      />
      <div className="max-w-md mx-auto text-center px-4">
        <div className="text-7xl font-bold text-[#2E5E99] mb-4">404</div>
        <h1 className="text-2xl font-bold text-[#0D2440] mb-3">
          {isDe ? 'Seite nicht gefunden' : 'Page not found'}
        </h1>
        <p className="text-[#5A7A9B] mb-8">
          {isDe
            ? 'Die angeforderte Seite existiert nicht oder wurde verschoben.'
            : 'The requested page does not exist or has been moved.'}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#0D2440] text-white rounded-xl h-12 px-6 font-medium hover:bg-[#162D4A] transition-colors"
            data-testid="not-found-home-link"
          >
            <ArrowLeft className="w-4 h-4" />
            {isDe ? 'Zur Startseite' : 'Back to home'}
          </Link>
          <Link
            to="/produktkatalog"
            className="inline-flex items-center justify-center gap-2 bg-white text-[#0D2440] border border-[#C8D8E8] rounded-xl h-12 px-6 font-medium hover:border-[#2E5E99] transition-colors"
            data-testid="not-found-catalog-link"
          >
            <Search className="w-4 h-4" />
            {isDe ? 'Produktkatalog' : 'Product catalog'}
          </Link>
        </div>
      </div>
    </div>
  );
}
